import { Klydo } from "../../../api/klydo";

/**
 * Re-orders klydos fetched by id (the by-ids endpoint returns them in its own
 * order) to match the given id list. Ids with no fetched klydo are skipped;
 * klydos not in the list are appended, so nothing is ever dropped.
 */
const orderKlydosByIds = (klydos: Klydo[], ids: string[]): Klydo[] => {
  const byId = new Map(klydos.map((k) => [k.id, k]));
  const ordered = ids
    .map((id) => byId.get(id))
    .filter((k): k is Klydo => Boolean(k));
  const seen = new Set(ordered.map((k) => k.id));
  return [...ordered, ...klydos.filter((k) => !seen.has(k.id))];
};

export default orderKlydosByIds;
